import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL3 } from '../Config/Base';
import { BASE_URL } from '../Config/Base';
import { Oval } from  'react-loader-spinner'

const pageSize = 5;
const pageSizeB = 5;
const pageSizeC = 5;
const pageSizeD = 5;

const OatEntityMain = () => {

  
const[pop,setpop] = useState(false);
const token = JSON.parse(localStorage.getItem('usertoken'));
let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
useEffect(()=>{  
  document.getElementById("PendingTable-Oat").style.display="none"
  getUsers()

   setpop(true);

   setTimeout(() => {
            
    getroleAction() 
    
     }, 1000);
  setTimeout(() => {
          
    setpop(false);
    getAssignedAction()
  
      
     }, 2000);

}, [])
function getroleAction(){


  let LoginRole= localStorage.getItem("Role");
  
 
  console.log('checkrole',LoginRole);
  const body =
  {
    
   role:LoginRole
  }
  console.log('body',body);
 
 
  axios({
         method:"POST",
         url :`${BASE_URL}/oat/GetOatRoleAction`,
         data:body, 
         headers: {
              "Content-type": "application/json",
              "Authorization": bearer,
          }     
      }) 
      
 
      .then((response) =>{
        console.log(response.data);
   
     
     
              
        localStorage.setItem("LoginAction",JSON.stringify(response.data))
        localStorage.getItem("LoginAction");
     })
     .catch(error => {
       console.log(error);
 })
 }

 function getAssignedAction(){



  ////Admin
    
    let LoginRoleId= localStorage.getItem("RoleId");

    let CheckSAdmin = LoginRoleId.includes("00")
    let CheckAdmin =LoginRoleId.includes("01")


  /////////////Teammate
    let LoginAction =  localStorage.getItem("LoginAction");
    let TecRoleAction =  JSON.parse(LoginAction);
    let roleAction = TecRoleAction.map((e)=>e.roleAction);
    console.log(roleAction);
    
    let roles = roleAction.toString();
    let roleResult = roles.includes('Add')
    console.log(roleResult)
    
    let roleResultA = roles.includes('View')
    console.log(roleResultA)
    
    let roleResultB = roles.includes('Edit')
    console.log(roleResultB)
    
    let roleResultC = roles.includes('Delete')
    console.log(roleResultC)


   

   
    if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){

      document.getElementById('PendingTable-Oat').style.display ="block";
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      document.getElementById('PendingTable-Oat').style.display ="block";
    }
    else{
      document.getElementById('PendingTable-Oat').style.display ="none";

    }



    if( roleResultA==false &&  CheckSAdmin==false && CheckAdmin==false){

      document.getElementById("OatActionDenied").innerHTML="View Table Denied"
    }
    
  }

  function getAssignedActionA(){



    ////Admin
      
      let LoginRoleId= localStorage.getItem("RoleId");
  
      let CheckSAdmin = LoginRoleId.includes("00")
      let CheckAdmin =LoginRoleId.includes("01")
  
  
    /////////////Teammate
      let LoginAction =  localStorage.getItem("LoginAction");
      let TecRoleAction =  JSON.parse(LoginAction);
      let roleAction = TecRoleAction.map((e)=>e.roleAction);
      console.log(roleAction);
      
      let roles = roleAction.toString();
      let roleResult = roles.includes('Add')
      console.log(roleResult)
      
      let roleResultA = roles.includes('View')
      console.log(roleResultA)
      
      let roleResultB = roles.includes('Edit')
      console.log(roleResultB)
      
      let roleResultC = roles.includes('Delete')
      console.log(roleResultC)
  
  
     
  
     
      if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('AllTable-Oat').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('AllTable-Oat').style.display ="block";
      }
      else{
        document.getElementById('AllTable-Oat').style.display ="none";
  
      }

      if( roleResultA==false &&  CheckSAdmin==false && CheckAdmin==false){

        document.getElementById("OatActionDeniedA").innerHTML="View Table Denied"
      }
      
    }

    const[editiconB,setediticonB] = useState(false);
    function getAssignedActionB(){



      ////Admin
        
        let LoginRoleId= localStorage.getItem("RoleId");
    
        let CheckSAdmin = LoginRoleId.includes("00")
        let CheckAdmin =LoginRoleId.includes("01")
    
    
      /////////////Teammate
        let LoginAction =  localStorage.getItem("LoginAction");
        let TecRoleAction =  JSON.parse(LoginAction);
        let roleAction = TecRoleAction.map((e)=>e.roleAction);
        console.log(roleAction);
        
        let roles = roleAction.toString();
        let roleResult = roles.includes('Add')
        console.log(roleResult)
        
        let roleResultA = roles.includes('View')
        console.log(roleResultA)
        
        let roleResultB = roles.includes('Edit')
        console.log(roleResultB)
        
        let roleResultC = roles.includes('Delete')
        console.log(roleResultC)
    
    
       
    
       
        if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
    
          document.getElementById('ActiveTable-Oat').style.display ="block";
        }
        else if(CheckSAdmin==true || CheckAdmin==true){
          document.getElementById('ActiveTable-Oat').style.display ="block";
        }
        else{
          document.getElementById('ActiveTable-Oat').style.display ="none";
    
        }


    
        if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
  
          setediticonB(true)
        }
        else if(CheckSAdmin==true || CheckAdmin==true){
          setediticonB(true)
        }
        else{
          setediticonB(false)
    
        }

  
        if(roleResultA==false  && CheckSAdmin==false && CheckAdmin==false){
  
          document.getElementById("OatActionDeniedB").innerHTML="View Table Denied"
        }
        
      }

      const[editiconC,setediticonC] = useState(false);
      function getAssignedActionC(){



        ////Admin
          
          let LoginRoleId= localStorage.getItem("RoleId");
      
          let CheckSAdmin = LoginRoleId.includes("00")
          let CheckAdmin =LoginRoleId.includes("01")
      
      
        /////////////Teammate
          let LoginAction =  localStorage.getItem("LoginAction");
          let TecRoleAction =  JSON.parse(LoginAction);
          let roleAction = TecRoleAction.map((e)=>e.roleAction);
          console.log(roleAction);
          
          let roles = roleAction.toString();
          let roleResult = roles.includes('Add')
          console.log(roleResult)
          
          let roleResultA = roles.includes('View')
          console.log(roleResultA)
          
          let roleResultB = roles.includes('Edit')
          console.log(roleResultB)
          
          let roleResultC = roles.includes('Delete')
          console.log(roleResultC)
      
      
         
      
         
          if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
      
            document.getElementById('InactiveTable-Oat').style.display ="block";
          }
          else if(CheckSAdmin==true || CheckAdmin==true){
            document.getElementById('InactiveTable-Oat').style.display ="block";
          }
          else{
            document.getElementById('InactiveTable-Oat').style.display ="none";
      
          }

          if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
  
            setediticonC(true)
          }
          else if(CheckSAdmin==true || CheckAdmin==true){
            setediticonC(true)
          }
          else{
            setediticonC(false)
      
          }
  
    
          if( roleResultA==false  && CheckSAdmin==false && CheckAdmin==false){
    
            document.getElementById("OatActionDeniedC").innerHTML="View Table Denied"
          }
          
        }
// GET request using fetch()
const [allusers, setAllusers] = useState([])


const [paginatedPosts, setpaginatedPosts] = useState();
const [currentPage, setcurrentPage] = useState(1);



function getUsers(){

    

fetch(`${BASE_URL}/OatMain/GetPending`, {

  method: 'GET',

  headers: {

    "Content-type": "application/json",

    "Accept": "application/json",

   

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

  },

  //body:JSON.stringify(data)

}).then(response => response.json())

  .then(data => {
    console.log("Data", data);
    setAllusers(data);
    setpaginatedPosts(_(data).slice(0).take(pageSize).value());
      }
  );

console.log("check",allusers)


    }

    const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;
    // if (pageCount === 1)
    // return null;
    
    const pages = _.range(1, pageCount+1)
    
    const pagination =(pageNo)=>{
    setcurrentPage(pageNo);
    const startIndex = (pageNo - 1) * pageSize;
    const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
    setpaginatedPosts(paginatedPost)
    }

    const onNext = () => {


      pagination(currentPage + 1);
    };
  
    const onPrevious = () => {
      pagination(currentPage - 1);
    };


    
// GET request using fetchB()


const [allusersB, setAllusersB] = useState([])


const [paginatedPostsB, setpaginatedPostsB] = useState();
const [currentPageB, setcurrentPageB] = useState(1);



function getUsersB(){

    

fetch(`${BASE_URL}/OatMain/Get_Status1`, {

  method: 'GET',

  headers: {

    "Content-type": "application/json",

    "Accept": "application/json",

   

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

  },

  //body:JSON.stringify(data)

}).then(response => response.json())

  .then(data => {
    console.log("Data", data);
    setAllusersB(data);
    setpaginatedPostsB(_(data).slice(0).take(pageSizeB).value());
      }
  );

console.log("check",allusersB)


    }

    const pageCountB = allusersB? Math.ceil(allusersB.length/pageSizeB) :0;
    // if (pageCount === 1)
    // return null;
    
    const pagesB = _.range(1, pageCountB+1)
    
    const paginationB =(pageNoB)=>{
    setcurrentPageB(pageNoB);
    const startIndexB = (pageNoB - 1) * pageSizeB;
    const paginatedPostB = _(allusersB).slice(startIndexB).take(pageSizeB).value();
    setpaginatedPostsB(paginatedPostB)
    }
    const onNextB = () => {


      paginationB(currentPageB + 1);
    };
  
    const onPreviousB = () => {
      paginationB(currentPageB - 1);
    };


    // GET request using fetchC()
const [allusersC, setAllusersC] = useState([])


const [paginatedPostsC, setpaginatedPostsC] = useState();
const [currentPageC, setcurrentPageC] = useState(1);



function getUsersC(){

    

fetch(`${BASE_URL}/OatMain/Get_status1`, {

  method: 'GET',

  headers: {

    "Content-type": "application/json",

    "Accept": "application/json",

   

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

  },

  //body:JSON.stringify(data)

}).then(response => response.json())

  .then(data => {
    console.log("Data", data);
    setAllusersC(data);
    setpaginatedPostsC(_(data).slice(0).take(pageSizeC).value());
      }
  );

console.log("check",allusersC)


    }

    const pageCountC = allusersC? Math.ceil(allusersC.length/pageSizeC) :0;
    // if (pageCount === 1)
    // return null;
    
    const pagesC = _.range(1, pageCountC+1)
    
    const paginationC =(pageNoC)=>{
    setcurrentPageC(pageNoC);
    const startIndexC = (pageNoC - 1) * pageSizeC;
    const paginatedPostC = _(allusersC).slice(startIndexC).take(pageSizeC).value();
    setpaginatedPostsC(paginatedPostC)
    }

    const onNextC = () => {


      paginationC(currentPageC + 1);
    };
  
    const onPreviousC = () => {
      paginationC(currentPageC - 1);
    };

// GET request using fetchD()
const [allusersD, setAllusersD] = useState([])


const [paginatedPostsD, setpaginatedPostsD] = useState();
const [currentPageD, setcurrentPageD] = useState(1);



function getUsersD(){

    

fetch(`${BASE_URL}/OatMain/InactiveOrg`, {

  method: 'GET',

  headers: {

    "Content-type": "application/json",

    "Accept": "application/json",

   

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

  },

  //body:JSON.stringify(data)

}).then(response => response.json())

  .then(data => {
    console.log("Data", data);
    setAllusersD(data);
    setpaginatedPostsD(_(data).slice(0).take(pageSizeD).value());
      }
  );

console.log("check",allusersD)


    }

    const pageCountD = allusersD? Math.ceil(allusersD.length/pageSizeD) :0;
    // if (pageCount === 1)
    // return null;
    
    const pagesD = _.range(1, pageCountD+1)
    
    const paginationD =(pageNoD)=>{
    setcurrentPageD(pageNoD);
    const startIndexD = (pageNoD - 1) * pageSizeD;
    const paginatedPostD = _(allusersD).slice(startIndexD).take(pageSizeD).value();
    setpaginatedPostsD(paginatedPostD)
    }

    const onNextD = () => {


      paginationD(currentPageD + 1);
    };
  
    const onPreviousD = () => {
      paginationD(currentPageD - 1);
    };

  function OpenPending(){
    document.getElementById("OatPendingTable").style.display="none"
    getUsers()
    setpop(true);
   
    document.getElementById("OatAllTable").style.display="none"
    document.getElementById("OatActiveTable").style.display="none"
   document.getElementById("OatInactiveTable").style.display="none"
   document.getElementById("oatPendingBtn").style.background="rgb(249, 249, 249)"
    document.getElementById("oatAllBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatEActiveBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatEInactiveBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatPendingBtn").style.color="black"
    document.getElementById("oatAllBtn").style.color="White"
    document.getElementById("oatEActiveBtn").style.color="White"
    document.getElementById("oatEInactiveBtn").style.color="White"
    setTimeout(() => {
      setpop(false);  
      getAssignedAction()
      document.getElementById("OatPendingTable").style.display="block"
      
       }, 1000);
  }

  function OpenAll(){
    document.getElementById("OatAllTable").style.display="none"
    getUsersB()
    setpop(true);
    document.getElementById("OatPendingTable").style.display="none"
    
    document.getElementById("OatActiveTable").style.display="none"
    document.getElementById("OatInactiveTable").style.display="none"
    document.getElementById("oatPendingBtn").style.background="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatAllBtn").style.background ="rgb(249, 249, 249)"
    document.getElementById("oatEActiveBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatEInactiveBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatPendingBtn").style.color="White"
    document.getElementById("oatAllBtn").style.color="black"
    document.getElementById("oatEActiveBtn").style.color="White"
    document.getElementById("oatEInactiveBtn").style.color="White"
 
    setTimeout(() => {
      setpop(false);  
      getAssignedActionA()
      document.getElementById("OatAllTable").style.display="block"
      
       }, 1000);
  }
  function OpenActive(){
    document.getElementById("OatActiveTable").style.display="none"
    getUsersC()
    setpop(true);

    document.getElementById("OatPendingTable").style.display="none"
    document.getElementById("OatAllTable").style.display="none"
   
    document.getElementById("OatInactiveTable").style.display="none"
    document.getElementById("oatPendingBtn").style.background="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatAllBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatEActiveBtn").style.background ="rgb(249, 249, 249)"
    document.getElementById("oatEInactiveBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatPendingBtn").style.color="White"
    document.getElementById("oatAllBtn").style.color="White"
    document.getElementById("oatEActiveBtn").style.color="black"
    document.getElementById("oatEInactiveBtn").style.color="White"
    setTimeout(() => {
      
      setpop(false);  
      getAssignedActionB()
      document.getElementById("OatActiveTable").style.display="block"
  }, 1000);
  
  }
    
      function OpenInactive(){
        document.getElementById("OatInactiveTable").style.display="none"
        getUsersD()
        setpop(true);
        document.getElementById("OatPendingTable").style.display="none"
        document.getElementById("OatAllTable").style.display="none"
        document.getElementById("OatActiveTable").style.display="none"
       
        document.getElementById("oatPendingBtn").style.background="linear-gradient(135deg,#a45bec,#7367f0)"
        document.getElementById("oatAllBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
        document.getElementById("oatEActiveBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
        document.getElementById("oatEInactiveBtn").style.background ="rgb(249, 249, 249)"
        document.getElementById("oatPendingBtn").style.color="White"
    document.getElementById("oatAllBtn").style.color="White"
    document.getElementById("oatEActiveBtn").style.color="White"
    document.getElementById("oatEInactiveBtn").style.color="black"
    setTimeout(() => {
      
      setpop(false);  
      getAssignedActionC()
      document.getElementById("OatInactiveTable").style.display="block"
  }, 1000);
 
  
  }
  

      ///function Select Details



      function SelectParticular(Company_Id){

        const body =
        {
          
          company_Id:Company_Id
        }
        console.log('body',body);
   
      
        axios({
               method:"POST",
               url :`${BASE_URL}/OatMain/GetParticular`,
               data:body, 
               headers: {
                    "Content-type": "application/json",
                    
                }     
            }) 
            
       
            .then((response) =>{
              console.log(JSON.stringify(response.data));
         
          
              setEditoat(response.data)
              setEditoatA(response.data)
              localStorage.setItem("EditOatActiveData",JSON.stringify(response.data))
         
           })
           .catch(error => {
             console.log(error);
             
           })
      }

      const [Editoat, setEditoat] =useState([])
      function EditStatus(Company_Id,Status){

        SelectParticular(Company_Id)
        setTimeout(() => {
          window.location.href="/?#/OatEditActivepop"
         // window.location.reload()
          
        }, 1000);
        // document.getElementById("ActiveEditPop").style.display = "block";
      }
      function closeActiveEditForm(){
        setActive(1)
        console.log(Active,"check Active")
        document.getElementById("oateditform").reset()
        document.getElementById("ErrA").innerHTML="  "

        document.getElementById("ActiveEditPop").style.display = "none";
      }

      const [Active, setActive] =useState()

      function ActiveEntity(){


        var Company_Id = document.getElementById("Company_Id_Oat").value;
        var Reason = document.getElementById("InActiveReason_oat").value;
        var Name =document.getElementById("Person_oat").value

        if(!Reason){

          document.getElementById("ErrA").innerHTML="Reason Required"
        }

        else{

          document.getElementById("ErrA").innerHTML="  "
        }

        if(Active===0){

          var Action =0
         }
         else if(Active===1){
          var Action= 1
    
         }
    
         else{
            var Action=1
    
         }

        if(Reason){
        
        const body =
        {
          company_Id:Company_Id,
          reason:Reason,
          status:Action,
          superAdmin_Id:"3dd01fa3-78f3-4080-bb1c-651b9af8389a"

         }

   
         axios({
          method:"POST",
          url :`${BASE_URL}/OatMain/InActiveStatus`,
          data:body, 
          headers: {
               "Content-Type": "application/json",
               
           }     
       }) 

      .then((response) =>{
      console.log(response.data);
 
 
      if(response.data.status === "Success"){
        
           //toast.success("InActivated " +Name)
          
        alert("InActivated " +Name)
           setTimeout(() => {
           
            getUsersC()

            closeActiveEditForm()
           }, 1000);
         }

         else if(response.data.status === "SameStatus"){
         // toast.info("Not Changed" +Name)
         alert("Not Changed" +Name)
        
          setTimeout(() => {
          
           getUsersC()

           closeActiveEditForm()
          }, 1000);

         }

 
   })
   .catch(error => {
     console.log(error);
     alert("failed !")
  

   })
     
 }

        
        }

        const [EditoatA, setEditoatA] =useState([])
        function EditStatusA(Company_Id,Status){
          // document.getElementById("ActiveEditPopA").style.display = "block";
          SelectParticular(Company_Id)
          setTimeout(() => {
            window.location.href="/?#/OatEditInactivepop"
           // window.location.reload()
            
          }, 1000);
         
        }
        function closeActiveEditFormA(){
          setInActive(0)
          console.log(InActive,"check InActive")
          document.getElementById("oateditformA").reset()
          document.getElementById("ErrB").innerHTML="  "
  
          document.getElementById("ActiveEditPopA").style.display = "none";
        }

        const [InActive, setInActive] =useState()
  
        function InActiveEntity(){
  
  
          var Company_Id = document.getElementById("Company_Id_OatA").value;
          var Reason = document.getElementById("ActiveReason_oat").value;
          var Name =document.getElementById("Person_oatA").value
  
          if(!Reason){
  
            document.getElementById("ErrB").innerHTML="Reason Required"
          }
  
          else{
  
            document.getElementById("ErrB").innerHTML="  "
          }
  
          if(InActive===0){
  
            var Action =0
           }
           else if(InActive===1){
            var Action= 1
      
           }
      
           else{
              var Action=0
      
           }
  
          if(Reason){
          
          const body =
          {
            company_Id:Company_Id,
            reason:Reason,
            status:Action,
            superAdmin_Id:"3dd01fa3-78f3-4080-bb1c-651b9af8389a"
  
           }
  
     
           axios({
            method:"POST",
            url :`${BASE_URL}/OatMain/ActiveStatus`,
            data:body, 
            headers: {
                 "Content-Type": "application/json",
                 
             }     
         }) 
  
        .then((response) =>{
        console.log(response.data);
    
        
        if(response.data.status === "Success"){
          
            //  toast.success("Activated " +Name)
            
          
           //localStorage.setItem("testing",Active)
           
          alert("Activated" +Name)
             setTimeout(() => {
             
              getUsersD()
  
              closeActiveEditFormA()
             }, 1000);
           }
           else if(response.data.status === "SameStatus"){
           // toast.info("Not Changed" +Name)
           alert("Not Changed" +Name)
          
            setTimeout(() => {
            
             getUsersD()
  
             closeActiveEditFormA()
            }, 1000);
  
           }
  
   
     })
     .catch(error => {
       console.log(error);
      alert("failed !")
    
  
     })
       
   }
  
          
          }

        
  return (
    <>
    
    <div className='oat-addmain'>
      
    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
        
    <div className="oat-addgrid-layout">
    
  <div className="oat-addmain-top">
    
    <span className='OatTitle'>
    <span>ENTITIES</span></span>
    <div className='oat-addmain-back'>
      <Link to="/Oatsection"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i><br></br><span>Back</span></Link>
      </div> 
   
    </div>
    </div>
      <div id="OatButton" >
           <div id="OatEntityHide">
            <button id="oatPendingBtn" onClick={OpenPending}>Pending</button>
            <button id="oatAllBtn" onClick={OpenAll}>All</button>
            <button id="oatEActiveBtn" onClick={OpenActive}>Active</button>
            <button id="oatEInactiveBtn" onClick={OpenInactive}>Inactive</button>
             </div>

      </div>

      {pop? <div id="Loader">
<Oval
  height={40}
  width={50}

  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}


      <div id="OatPendingTable">
    
<div id="PendingTable-Oat">
{
  allusers.length==0  ? (<div id="OatApiFail">" No Data Found "</div>):(
<div>
        <div className='oattable'>

<div class="oat-table_responsive">

<table> 
    <thead>
   <tr>


   <th>Entity_Name</th>
<th>Mobile Number</th>
<th>Primary Email</th>
<th>Location</th>

<th>Contact</th>
<th>Status</th>



</tr>
</thead>
<tbody>
{paginatedPosts.map((e,index) => {
      return<tr key={index}>

         
         <td>{e.company_Name}</td>
          <td>{e.mobile}</td>
          <td>{e.email}</td>
          <td>{e.city}</td>
          <td>{e.personname}</td>
          
          <td id="OatPendingData">Pending</td>
          
  </tr>})}
  </tbody>

</table>


</div></div>
<br></br>
{pageCount==1?null:<nav id="oatpagenav" style={{marginTop:"50px"}}>
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      } */}
          {currentPage >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="oatpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}
  </div>)} 
  </div>
  <div id="OatDenied">
   <span id="OatActionDenied"></span>

   </div>
        </div>
        
      <div id="OatAllTable">
        <div id="AllTable-Oat">
        {
 allusersB.length==0  ? (<div id="OatApiFail">" No Data Found "</div>):(
<div>
      <div className='oattable'>

<div class="oat-table_responsive">

<table> 
    <thead>
   <tr>
   <th style={{whiteSpace:"nowrap"}}>Entity_Name</th>
<th style={{whiteSpace:"nowrap"}}>Mobile Number</th>
<th style={{whiteSpace:"nowrap"}}>Primary Email</th>
<th style={{whiteSpace:"nowrap"}}>Location</th>

<th style={{whiteSpace:"nowrap"}}>Contact</th>
<th style={{whiteSpace:"nowrap"}}>Status</th>

</tr>
</thead>
<tbody>
{paginatedPostsB.map((e,index) => {
      return<tr key={index}>
       <td>{e.company_Name}</td>
       
          <td>{e.mobile}</td>
          <td>{e.email}</td>
          <td>{e.city}</td>
         
          <td>{e.personname}</td>
          {/* <td> {e.status}</td> */}
          {e.status==0?<td id="OatInActiveData">Inactive</td>:e.status==1?<td id="OatActiveData">Active</td>:e.status==2?<td id="OatPendingData">Pending</td>:<td>{e.status}</td>}
   
  </tr>})}
  </tbody>

</table>


</div></div>
<br></br>
{pageCountB==1?null:<nav id="oatpagenav" style={{marginTop:"50px"}}>
    <ul className='pagination'>
      {/* {
        pagesB.map((page)=>(
          <li className={
            page === currentPageB ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>paginationB(page)}
            >
            {page}
            </p>
            </li>
        ))
      } */}
          {currentPageB >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPreviousB} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPageB} Of {pageCountB} 
         
            </span>   &nbsp; &nbsp;
        {currentPageB<pageCountB?<li className="page-item">
              <a class="oatpage-link" onClick={onNextB} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}
  </div>)} 
  </div>
  <div id="OatDenied">
   <span id="OatActionDeniedA"></span>

   </div>
        </div>
        <div id="OatActiveTable">
   <div id="ActiveTable-Oat">
   {
  allusersC.length==0 ? (<div id="OatApiFail">" No Data Found "</div>):(
<div>
        <div className='oattable'>

<div class="oat-table_responsive">

<table> 
    <thead>
   <tr>
   <th style={{whiteSpace:"nowrap"}}>Entity_Name</th>
<th style={{whiteSpace:"nowrap"}}>Mobile Number</th>
<th style={{whiteSpace:"nowrap"}}>Primary Email</th>
<th style={{whiteSpace:"nowrap"}}>Location</th>

<th style={{whiteSpace:"nowrap"}}>Contact</th>
<th style={{whiteSpace:"nowrap"}}>Status</th>
<th style={{whiteSpace:"nowrap"}}>Action</th>
</tr>
</thead>
<tbody>
{paginatedPostsC.map((e,index) => {
      return<tr key={index}>

         <td>{e.company_Name}</td>
          <td>{e.mobile}</td>
          <td>{e.email}</td>
          <td>{e.city}</td>
          <td>{e.personname}</td>
          <td id="OatActiveData">Active</td>
                 
          <td> 
          {editiconB? <span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>EditStatus(e.company_Id,e.status)}  id="OatEditicon"></i></span>:
            <span id="OatInActiveData">Denied</span>}
            </td>
  </tr>})}
  </tbody>

</table>


</div></div>
<br></br>
{pageCountC==1?null:<nav id="oatpagenav" style={{marginTop:"50px"}}>
    <ul className='pagination'>
      {/* {
        pagesC.map((page)=>(
          <li className={
            page === currentPageC ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>paginationC(page)}
            >
            {page}
            </p>
            </li>
        ))
      } */}

{currentPageC >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPreviousC} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPageC} Of {pageCountC} 
         
            </span>   &nbsp; &nbsp;
        {currentPageC<pageCountC?<li className="page-item">
              <a class="oatpage-link" onClick={onNextC} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
       

    </ul>
  </nav>}
  </div>)} 
  </div>
     {/* EditActivePop */}
 {/* <div className='tec-pop-fade' id="ActiveEditPop">
{Editoat.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"90px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT ACTIVE</h4>
        <button type="button" className="close" onClick={closeActiveEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="oateditform" onSubmit={ActiveEntity}>
      <div className="modal-body mx-3">
      <div className="md-form mb-5">
        <label id="sectionlable">Entity_Name</label>
     
         <input type="text" defaultValue={e.company_Name} readOnly/>
         <input type="text" defaultValue={e.company_Id} style={{display:"none"}}id="Company_Id_Oat" readOnly/>
        </div>
        
        <div className="md-form mb-5">
        <label id="sectionlable">Contact_Person</label> 
          <input type="text"  id="Person_oat"  defaultValue={e.personname} readOnly/>
        
        </div> 
        <div className="md-form mb-5">
        <label id="sectionlable">Inactive Reason</label> 
          <input type="text" id="InActiveReason_oat" />
          <span id="ErrA" className='error'></span>
        </div> 

        <div className="md-form mb-3">

  


           {e.status===1 ? 
         <center>
          <input type="checkbox" id="oatactiveswitchA"
              className="Activecheckbox"  onChange={()=>setActive(0)}/>
            <label for="oatactiveswitchA" className="oattoggleactive">
       

           <p className='ActiveLable'>Active &nbsp;&nbsp;&nbsp;Inactive</p>


          </label>

          </center>
             :
             <center>
        <input type="checkbox" id="oatinactiveswitchA"
         class="InActivecheckbox"  onChange={()=>setActive(1)}/>
            <label for="oatinactiveswitchA" className="oattoggleinactive">
  

           <p className='InActiveLable'>Active&nbsp; &nbsp;&nbsp;Inactive</p>


             </label>

       </center>


     }



</div>
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='oat-adduser-button' type="submit">Save Changes</button>
      </div>
      </form>
    </div>
  </div>})}
  
</div> */}
<div id="OatDenied">
   <span id="OatActionDeniedB"></span>

   </div>
        </div>
        <div id="OatInactiveTable">
<div id="InactiveTable-Oat">
{
  allusersD.length==0 ? (<div id="OatApiFail">" No Data Found "</div>):(
<div>
        <div className='oattable'>

<div class="oat-table_responsive">

<table> 
    <thead>
   <tr>
   <th style={{whiteSpace:"nowrap"}}>Entity_Name</th>
<th style={{whiteSpace:"nowrap"}}>Mobile Number</th>
<th style={{whiteSpace:"nowrap"}}>Primary Email</th>
<th style={{whiteSpace:"nowrap"}}>Location</th>

<th style={{whiteSpace:"nowrap"}}>Contact</th>
<th style={{whiteSpace:"nowrap"}}>Status</th>
<th style={{whiteSpace:"nowrap"}}>Action</th>
</tr>
</thead>
<tbody>
{paginatedPostsD.map((e,index) => {
      return<tr key={index}>

          <td>{e.company_Name}</td>
          <td>{e.mobile}</td>
          <td>{e.email}</td>
          <td>{e.city}</td>
          <td>{e.personname}</td>
         
          <td id="OatInActiveData">Inactive</td>
          <td>
             {editiconC?<span><i class="fa fa-pencil" aria-hidden="true"   id="OatEditicon" onClick={()=>EditStatusA(e.company_Id,e.status)} ></i></span>:
            <span id="OatInActiveData">Denied</span>}
             
             </td>
  </tr>})}
  </tbody>

</table>


</div></div>
<br></br>
{pageCountD==1?null:<nav id="oatpagenav" style={{marginTop:"50px"}}>
    <ul className='pagination'>
      {/* {
        pagesD.map((page)=>(
          <li className={
            page === currentPageD ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>paginationD(page)}
            >
            {page}
            </p>
            </li>
        ))
      } */}
       
       {currentPageD >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPreviousD} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPageD} Of {pageCountD} 
         
            </span>   &nbsp; &nbsp;
        {currentPageD<pageCountD?<li className="page-item">
              <a class="oatpage-link" onClick={onNextD} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
    </ul>
  </nav>}
  </div>)}
  </div>

     {/* EditActivePop */}
 {/* <div className='tec-pop-fade' id="ActiveEditPopA">
{EditoatA.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"90px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT ACTIVE</h4>
        <button type="button" className="close" onClick={closeActiveEditFormA}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="oateditformA" onSubmit={InActiveEntity}>
      <div className="modal-body mx-3">
      <div className="md-form mb-5">
        <label id="sectionlable">Entity_Name</label>
     
         <input type="text" defaultValue={e.company_Name} readOnly/>
         <input type="text" defaultValue={e.company_Id} style={{display:"none"}}id="Company_Id_OatA" readOnly/>
        </div>
        
        <div className="md-form mb-5">
        <label id="sectionlable">Contact_Person</label> 
          <input type="text"  id="Person_oatA"  defaultValue={e.personname} readOnly/>
        
        </div> 
        <div className="md-form mb-5">
        <label id="sectionlable">Active Reason</label> 
          <input type="text" id="ActiveReason_oat" />
          <span id="ErrB" className='error'></span>
        </div> 

        <div className="md-form mb-3">

  


           {e.status===1 ? 
         <center>
          <input type="checkbox" id="oatactiveswitch"
              className="Activecheckbox"  onChange={()=>setInActive(0)}/>
            <label for="oatactiveswitch" className="oattoggleactive">
       

           <p className='ActiveLable'>Active &nbsp;&nbsp;&nbsp;Inactive</p>


          </label>

          </center>
             :
             <center>
        <input type="checkbox" id="oatinactiveswitch"
         class="InActivecheckbox"  onChange={()=>setInActive(1)}/>
            <label for="oatinactiveswitch" className="oattoggleinactive">
  

           <p className='InActiveLable'>Active&nbsp; &nbsp;&nbsp;Inactive</p>


             </label>

       </center>


     }



</div>
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='oat-adduser-button' type="submit">Save Changes</button>
      </div>
      </form>
    </div>
  </div>})}
  
</div> */}
  <div id="OatDenied">
   <span id="OatActionDeniedC"></span>

   </div>
        </div>

      </div>
    </>
  )
}

export default OatEntityMain
